import Aspect from "../Aspect/Aspect";
import Image from "../Image/Image";
import cn from "classnames";

export type CardContainerProps = {
  onClick?: () => void;
  imageUrl?: string;
  children: React.ReactNode;
  link?: {
    linkText: string;
    linkIcon?: string
  }
  cardOrientation?: 'vertical' | 'horizontal';
};

export const Card = ({ onClick, imageUrl, children, link, cardOrientation = 'vertical' }: CardContainerProps) => {
  return (
    <a className={cn({ "cursor-pointer": !!onClick })} onClick={onClick}>
      <div id='card-container' className={cn('group/cardContainer rounded-lg h-full shadow-lg flex gap-0 overflow-hidden bg-surface-0 desktop:transition-transform desktop:transform desktop:hover:scale-105', {
        'flex-row': cardOrientation === 'horizontal',
        'flex-col': cardOrientation === 'vertical',
      })}>
        <Aspect ratio="2/1">
          <Image src={imageUrl} alt='Card Image' classNames={cn({['w-full h-full rounded-t-lg']: cardOrientation === 'vertical', ['h-auto w-auto']: cardOrientation === 'horizontal'})} />
        </Aspect>
        <div className="flex flex-col justify-between grow h-full p-4">
          {children}
          <div className="w-full flex justify-end items-center gap-1">
            <span className="font-texts font-bold text-base text-neutral-900 group-hover/cardContainer:underline">
              {link?.linkText || 'Ver más'}
            </span>
            <span className="material-symbols-outlined text-3xl text-neutral-900 font-bold">
              {link?.linkIcon || 'arrow_forward'}
            </span>
          </div>
        </div>
      </div>
    </a>
  )
}


